import { LDClient, LDFlagValue } from 'ldclient-js';

import { ReportingConfig } from '@opengov/app-config-reporting';
import { ILaunchDarklyParams, ldInitialize, sessionToLDUser } from '@opengov/launchdarkly';

import { composeEffects } from '../module';

import { FeatureFlagStatus, launchDarklyActionCreators } from './launchDarklyState';

export const launchDarklyEnvironmentKey = ReportingConfig.LAUNCH_DARKLY_ENV_KEY;

export const isLaunchDarklyAvailable = !!launchDarklyEnvironmentKey;

const initializeLd = ldInitialize(
  isLaunchDarklyAvailable,
  launchDarklyEnvironmentKey,
  launchDarklyActionCreators.receivedChangeNotification
);

export const launchDarklyEffects = composeEffects('launch-darkly', compose => ({
  initialize: compose.effect(initializeLd),

  identify: compose.effect(
    async (params: ILaunchDarklyParams): Promise<LDClient> => {
      return initializeLd(params).then(async initializedClient => {
        return initializedClient.identify(sessionToLDUser(params)).then(() => initializedClient);
      });
    }
  ),

  allFlags: compose.effect(
    async (params: ILaunchDarklyParams): Promise<{ [k: string]: any }> => {
      launchDarklyActionCreators.setFeatureFlagStatus(FeatureFlagStatus.Loading);

      return launchDarklyEffects.identify(params).then(async initializedClient => {
        const allFlags = initializedClient.allFlags();
        launchDarklyActionCreators.receivedAllFlags(allFlags);

        launchDarklyActionCreators.setFeatureFlagStatus(FeatureFlagStatus.Current);
        return Promise.resolve(allFlags);
      });
    }
  ),

  variation: compose.effect(
    async (effect: { params: ILaunchDarklyParams; key: string }): Promise<LDFlagValue> => {
      return launchDarklyEffects.identify(effect.params).then(async initializedClient => {
        const value = initializedClient.variation(effect.key);
        launchDarklyActionCreators.receivedVariation({ key: effect.key, value });
        return value;
      });
    }
  )
}));
